type UseInfoPointDirectionParameters = {
    blockClass: string;
    blockElement: HTMLElement;
    mapElement: HTMLDivElement;
    hasFlippedInfoPoints: boolean;
    useViewportAsLimiter: boolean;
};

type HorizontalLimiter = {
    left: number;
    right: number;
};

const useInfoPointDirection = ({
    blockClass,
    blockElement,
    mapElement,
    hasFlippedInfoPoints,
    useViewportAsLimiter,
}: UseInfoPointDirectionParameters) => {
    const flippedDetailsClass = `${blockClass}__info-point-details--flipped`;
    const overflowPadding = 8;

    const getLimiterBounds = (): HorizontalLimiter => {
        if (!useViewportAsLimiter) {
            const mapBounds = mapElement.getBoundingClientRect();

            return {
                left: mapBounds.left,
                right: mapBounds.right,
            };
        }

        const visualViewport = window.visualViewport;
        const viewportLeft = visualViewport?.offsetLeft ?? 0;
        const viewportWidth = visualViewport?.width ?? window.innerWidth;

        return {
            left: viewportLeft,
            right: viewportLeft + viewportWidth,
        };
    };

    const updateDirection = (number: string): void => {
        const infoPointElement = blockElement.querySelector<HTMLDivElement>(`.${blockClass}__info-point[data-number='${number}']`);
        const infoPointDetailsElement = infoPointElement?.querySelector<HTMLElement>(`.${blockClass}__info-point-details`);

        if (!infoPointDetailsElement) {
            return;
        }

        requestAnimationFrame(() => {
            const limiterBounds = getLimiterBounds();

            infoPointDetailsElement.classList.toggle(flippedDetailsClass, hasFlippedInfoPoints);

            const infoPointDetailsBounds = infoPointDetailsElement.getBoundingClientRect();

            if (hasFlippedInfoPoints) {
                const extendsBeyondLeftEdge = infoPointDetailsBounds.left < limiterBounds.left + overflowPadding;

                if (extendsBeyondLeftEdge) {
                    infoPointDetailsElement.classList.remove(flippedDetailsClass);
                }

                return;
            }

            const extendsBeyondRightEdge = infoPointDetailsBounds.right > limiterBounds.right - overflowPadding;

            if (extendsBeyondRightEdge) {
                infoPointDetailsElement.classList.add(flippedDetailsClass);
            }
        });
    };

    return {
        updateDirection,
    };
};

export default useInfoPointDirection;
